import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public ru = RU;
    public view: string = 'login';
    public errorMessage: string = '';

    public loginData: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        email: '',
        password: '',
        passwordConfirm: '',
        name: '',
        level: 'beginner'
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) {
            if (this.service.auth.session?.role === 'admin') {
                return location.href = "/admin/dashboard";
            }
            return location.href = "/dashboard";
        }
    }

    public async switchView(view: string) {
        this.view = view;
        this.errorMessage = '';
        await this.service.render();
    }

    private async showError(message: string) {
        this.errorMessage = message;
        await this.service.render();
    }

    public async login() {
        this.errorMessage = '';
        let user = JSON.parse(JSON.stringify(this.loginData));
        if (!user.email) {
            await this.showError(this.ru.auth_error_email);
            return;
        }
        if (!user.password) {
            await this.showError(this.ru.auth_error_password);
            return;
        }

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            if (data?.role === 'admin') {
                location.href = "/admin/dashboard";
            } else {
                location.href = "/dashboard";
            }
        } else {
            await this.showError(data.message || this.ru.auth_error_invalid);
        }
    }

    public async signup() {
        this.errorMessage = '';
        let d = this.signupData;
        if (!d.name) {
            await this.showError(this.ru.auth_error_name);
            return;
        }
        if (!d.email) {
            await this.showError(this.ru.auth_error_email);
            return;
        }
        if (!d.password) {
            await this.showError(this.ru.auth_error_password);
            return;
        }
        if (d.password.length < 6) {
            await this.showError(this.ru.auth_error_password_short);
            return;
        }
        if (d.password !== d.passwordConfirm) {
            await this.showError(this.ru.auth_error_password_match);
            return;
        }

        let params = {
            email: d.email,
            password: d.password,
            name: d.name,
            level: d.level
        };

        let { code, data } = await wiz.call("signup", params);

        if (code == 200) {
            location.href = "/dashboard";
        } else {
            await this.showError(data.message || this.ru.error);
        }
    }
}

export default PageAccessComponent;